import React from "react";
import videoPlay from "../../../images/video-play.png";

export default function Thumbnail({ image, index }) {
  const video =
    image.image.includes("youtube") || image.image.includes("youtu.be");

  if (video) {
    const id = image.image
      .split("/")
      .pop()
      .replace("watch?v=", "");

    return (
      <div className="thumbnail" key={"slider-nav-image-" + index}>
        <img src={`https://i1.ytimg.com/vi/${id}/default.jpg`} alt="" />
        <img className="video" src={videoPlay} alt="" />
      </div>
    );
  }
  return (
    <div key={"slider-nav-image-" + index}>
      <img src={image.image} alt="" />
    </div>
  );
}
